<template>
  <div class="page-container">
    <md-app md-mode="fixed">
      <md-app-toolbar class="md-primary md-dense">
        <top-navigation
          :hideAccount="hideToolbarAccount"
          @toggle-menu="drawerActive = !drawerActive"
        />
      </md-app-toolbar>

      <md-app-drawer
        class="md-elevation-4"
        md-permanent="clipped"
        :md-active.sync="drawerActive"
      >
        <side-menu />
      </md-app-drawer>

      <md-app-content>
        <router-view />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import TopNavigation from './TopNavigation'
import SideMenu from './SideMenu'

export default {
  props: {
    hideToolbarAccount: Boolean,
  },

  data: () => ({
    drawerActive: false,
  }),

  components: {
    TopNavigation,
    SideMenu,
  },

  beforeRouteUpdate(to, from, next) {
    this.drawerActive = false
    next()
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 300px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(#000, 0.12);
}

.md-app {
  height: 100vh;

  &-drawer {
    width: 220px;
  }

  &-content {
    // min-height: 800px;
    padding: 0px;
  }
}

.md-primary.md-dense {
  max-height: 48px;
}
</style>
<style lang="scss">
body {
  overflow: hidden;
}
.md-menu-content-huge {
  max-width: 500px !important;
}
</style>
